import HttpRequest from '@/lib/request'
export const backendServer = "https://api.weiquanai.com"
//export const backendServer = "http://localhost:8081"
export const jwtServerInstance = new HttpRequest(backendServer)
